// useAssignmentActions.js — 누르는 방식의 배정 동작 (2026-10-06, 마케터 1:1 휴대폰·UX 2단계)
//   배정 줄 누르기 → 배정 상세 창 → [담당 마케터 바꾸기] [배정 끝내기] [기간·메모 고치기] [급여 조건] [지우기]
//   배정 안 된 직원 [배정하기] → 마케터 고르기 → 배정 창.
//   마케터를 고른 뒤에는 끌어놓기가 부르던 함수(openMove/openAdd)를 그대로 부른다 — 서버로 가는 요청이 같다.
//   상세·조건 창은 배정 번호만 들고, 그릴 때 최신 배정 목록에서 다시 찾는다(저장 뒤 새 값이 바로 보이게).
import { useState } from 'react';

export function useAssignmentActions({ assignments = [], openAdd, openEdit, openMove, openEnd, handleDelete }) {
  const [detailId, setDetailId] = useState(null);
  const [rulesId, setRulesId] = useState(null);
  const [picker, setPicker] = useState(null); // { purpose: 'move'|'assign', assignment?, consultant? }

  const findRow = (id) => (id ? assignments.find((row) => Number(row.id) === Number(id)) || null : null);
  const detailRow = findRow(detailId);
  const rulesRow = findRow(rulesId);

  function openDetail(row) {
    if (row?.id) setDetailId(row.id);
  }

  function closeDetail() {
    setDetailId(null);
  }

  function requestMove(row) {
    setDetailId(null);
    setPicker({ purpose: 'move', assignment: row });
  }

  function requestAssign(consultant) {
    setPicker({ purpose: 'assign', consultant });
  }

  function closePicker() {
    setPicker(null);
  }

  // 고르기 창을 닫은 뒤 다음 창을 연다(창 위에 창을 겹치지 않음)
  function pickMarketer(marketer) {
    const current = picker;
    setPicker(null);
    if (!current || !marketer) return;
    if (current.purpose === 'move') openMove(current.assignment, marketer);
    else openAdd(marketer, current.consultant || null);
  }

  function requestEnd(row) {
    setDetailId(null);
    openEnd(row);
  }

  function requestEdit(row) {
    setDetailId(null);
    openEdit(row);
  }

  function requestRules(row) {
    setDetailId(null);
    setRulesId(row?.id || null);
  }

  function closeRules() {
    setRulesId(null);
  }

  // 지우기 확인창은 handleDelete 가 띄운다(종전과 같은 문구·요청)
  function requestDelete(row) {
    setDetailId(null);
    handleDelete(row.id);
  }

  return {
    detailRow,
    rulesRow,
    picker,
    openDetail,
    closeDetail,
    requestMove,
    requestAssign,
    closePicker,
    pickMarketer,
    requestEnd,
    requestEdit,
    requestRules,
    closeRules,
    requestDelete,
  };
}
